import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import type { BreadcrumbItem } from '../components/Breadcrumb';

type BreadcrumbContextValue = {
    items: BreadcrumbItem[];
    setItems: (items: BreadcrumbItem[]) => void;
};

const BreadcrumbContext = createContext<BreadcrumbContextValue>({
    items: [],
    setItems: () => {},
});

export const BreadcrumbProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [items, setItems] = useState<BreadcrumbItem[]>([]);
    const value = useMemo(() => ({ items, setItems }), [items]);
    return <BreadcrumbContext.Provider value={value}>{children}</BreadcrumbContext.Provider>;
};

export const useBreadcrumbContext = () => useContext(BreadcrumbContext);

export const useBreadcrumb = (items: BreadcrumbItem[]) => {
    const { setItems } = useContext(BreadcrumbContext);
    const serialized = JSON.stringify(items);
    const stableSet = useCallback(setItems, [setItems]);
    useEffect(() => {
        stableSet(JSON.parse(serialized));
        return () => stableSet([]);
    }, [serialized, stableSet]);
};
